"use client";

import { c as _c } from "react/compiler-runtime";
import EmailIcon from "@/Components/website/common/Icons/EmailIcon";
import GreenCheck from "@/Components/website/common/Icons/GreenCheck";
import LockIconOutline from "@/Components/website/common/Icons/LockIconOutline";
import UserIcon from "@/Components/website/common/Icons/UserIcon";
import { useRepsSignupMutation } from "@/Redux/apis/reps";
import { userData } from "@/Redux/apis/userData";
import { setToken } from "@/Redux/slice/token";
import { getCurrentSystemTimezone } from "@/utils/common";
import Cookies from "js-cookie";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
const RepsHerosections = () => {
  const $ = _c(136);
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  let t0;
  if ($[0] !== isPasswordVisible) {
    t0 = () => {
      setPasswordVisible(!isPasswordVisible);
    };
    $[0] = isPasswordVisible;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const togglePasswordVisibility = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: ""
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [signup, setSignup] = useState(t1);
  useSelector(_temp);
  useSelector(_temp2);
  const [, setLoading] = useState(false);
  const [userSignup, response] = useRepsSignupMutation();
  const [error, setError] = useState("");
  const {
    register,
    handleSubmit,
    formState: t2
  } = useForm();
  const {
    errors,
    isSubmitting
  } = t2;
  const router = useRouter();
  const dispatch = useDispatch();
  let t3;
  if ($[3] !== signup) {
    t3 = e => {
      const {
        name,
        value
      } = e.target;
      setSignup({
        ...signup,
        [name]: value
      });
    };
    $[3] = signup;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onChangeHandler = t3;
  let t4;
  if ($[5] !== signup.confirmPassword || $[6] !== signup.email || $[7] !== signup.firstName || $[8] !== signup.lastName || $[9] !== signup.password || $[10] !== userSignup) {
    t4 = async e_0 => {
      const payload = {
        email: signup.email,
        firstName: signup.firstName,
        lastName: signup.lastName,
        password: signup.password,
        confirmPassword: signup.confirmPassword,
        timezone: getCurrentSystemTimezone()
      };
      await userSignup(payload);
    };
    $[5] = signup.confirmPassword;
    $[6] = signup.email;
    $[7] = signup.firstName;
    $[8] = signup.lastName;
    $[9] = signup.password;
    $[10] = userSignup;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const onSubmit = t4;
  let t5;
  if ($[12] !== dispatch || $[13] !== response?.data?.isAccountData || $[14] !== response?.data?.isVerifiedAccount || $[15] !== response?.data?.token || $[16] !== response?.error?.data?.message || $[17] !== response?.error?.status || $[18] !== response?.isError || $[19] !== response?.isLoading || $[20] !== response?.isSuccess || $[21] !== response?.status || $[22] !== router) {
    t5 = async () => {
      if (response?.isLoading) {
        setLoading(true);
        return;
      }
      if (response?.isSuccess) {
        const token_0 = response?.data?.token;
        response?.data?.reps;
        Cookies.set("token", token_0);
        Cookies.set("isReps", "true");
        dispatch(setToken(token_0));
        await dispatch(userData({
          token: token_0,
          type: "reps"
        }));
        setLoading(false);
        if (response?.data?.isVerifiedAccount && response?.data?.isAccountData) {
          setError("account already registered please login");
        } else {
          if (response?.data?.isVerifiedAccount && !response?.data?.isAccountData) {
            toast.success("signup successfully");
            await router.push("/reps/account-setup");
          } else {
            await router.push("/reps/two-factor-verification");
            toast.success("Verify your email");
          }
        }
        return;
      }
      if (response?.isError && response?.status === "rejected" && [400, 500].includes(response?.error?.status)) {
        setError(response?.error?.data?.message);
        setLoading(false);
      }
    };
    $[12] = dispatch;
    $[13] = response?.data?.isAccountData;
    $[14] = response?.data?.isVerifiedAccount;
    $[15] = response?.data?.token;
    $[16] = response?.error?.data?.message;
    $[17] = response?.error?.status;
    $[18] = response?.isError;
    $[19] = response?.isLoading;
    $[20] = response?.isSuccess;
    $[21] = response?.status;
    $[22] = router;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  const handleResponse = t5;
  let t6;
  let t7;
  if ($[24] !== handleResponse) {
    t6 = () => {
      handleResponse();
    };
    t7 = [handleResponse];
    $[24] = handleResponse;
    $[25] = t6;
    $[26] = t7;
  } else {
    t6 = $[25];
    t7 = $[26];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="text-[32px] md:text-[40px] lg:text-[48px] leading-tight text-white font-semibold">Join Alpha.MD as Representative and connect with an Expanding Network of Healthcare Providers</div>;
    t9 = <div className="text-white text-[14px] md:text-[16px] leading-tight pt-5 lg:pt-10 font-medium lg:w-[65%] mx-auto lg:mx-0 opacity-70">{"With Alpha.MD reps can find the healthcare providers that align well with their products & connect with them"}</div>;
    $[27] = t8;
    $[28] = t9;
  } else {
    t8 = $[27];
    t9 = $[28];
  }
  let t10;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="properties-bg p-2 flex items-start gap-2"><GreenCheck /><div className="text-[14px] md:text-[16px] font-medium text-white">Verified Practices</div></div>;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex items-center flex-wrap justify-center lg:justify-start gap-4">{t10}<div className="properties-bg p-2 flex items-start gap-2"><GreenCheck /><div className="text-[14px] md:text-[16px] font-medium text-white">Faster Onboarding</div></div></div>;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="lg:w-[55%] w-full text-center lg:text-left">{t8}{t9}<div className="space-y-5 pt-5 lg:pt-10">{t11}<div className="flex items-center flex-wrap justify-center lg:justify-start gap-4"><div className="properties-bg p-2 flex items-start gap-2"><GreenCheck /><div className="text-[14px] md:text-[16px] font-medium text-white">Easy Product Listing</div></div></div></div></div>;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== handleSubmit || $[33] !== onSubmit) {
    t13 = handleSubmit(onSubmit);
    $[32] = handleSubmit;
    $[33] = onSubmit;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== error) {
    t14 = error && <div className="text-sm mt-3 w-full bg-red-500/10 text-red-600 px-3 py-2 rounded-lg">{error}</div>;
    $[35] = error;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="text-smokeGrey font-medium text-[14px] md:text-[16px]">First name</div>;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <UserIcon />;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== register) {
    t17 = register("firstName", {
      required: "first name is required"
    });
    $[39] = register;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== onChangeHandler || $[42] !== signup.firstName || $[43] !== t17) {
    t18 = <div className="flex items-center border border-borderLightGrey rounded-lg p-2 gap-2">{t16}<input {...t17} onChange={onChangeHandler} type="text" name="firstName" value={signup.firstName} placeholder="Enter your first name" className="w-full border-none py-1 outline-none" /></div>;
    $[41] = onChangeHandler;
    $[42] = signup.firstName;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== errors.firstName) {
    t19 = errors.firstName ? <div className=" text-red-500 text-sm ">{errors.firstName.message}</div> : "";
    $[45] = errors.firstName;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t18 || $[48] !== t19) {
    t20 = <div className="space-y-2 flex flex-col">{t15}{t18}{t19}</div>;
    $[47] = t18;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="text-smokeGrey font-medium text-[14px] md:text-[16px]">Last name</div>;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <UserIcon />;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== register) {
    t23 = register("lastName", {
      required: "last name is required"
    });
    $[52] = register;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== onChangeHandler || $[55] !== signup.lastName || $[56] !== t23) {
    t24 = <div className="flex items-center border border-borderLightGrey rounded-lg p-2 gap-2">{t22}<input {...t23} onChange={onChangeHandler} type="text" name="lastName" value={signup.lastName} placeholder="Enter your last name" className="w-full border-none py-1 outline-none" /></div>;
    $[54] = onChangeHandler;
    $[55] = signup.lastName;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== errors.lastName) {
    t25 = errors.lastName ? <div className="  text-red-500 text-sm ">{errors.lastName.message}</div> : "";
    $[58] = errors.lastName;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== t24 || $[61] !== t25) {
    t26 = <div className="space-y-2 flex flex-col">{t21}{t24}{t25}</div>;
    $[60] = t24;
    $[61] = t25;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="text-smokeGrey font-medium text-[14px] md:text-[16px]">Your email</div>;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <EmailIcon />;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== register) {
    t30 = register("email", {
      required: "email is required",
      pattern: {
        value: t29,
        message: "Invalid email address"
      }
    });
    $[66] = register;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== onChangeHandler || $[69] !== signup.email || $[70] !== t30) {
    t31 = <div className="flex items-center border border-borderLightGrey rounded-lg p-2 gap-2">{t28}<input {...t30} onChange={onChangeHandler} type="email" name="email" value={signup.email} placeholder="Enter your email" className="w-full border-none py-1 outline-none" /></div>;
    $[68] = onChangeHandler;
    $[69] = signup.email;
    $[70] = t30;
    $[71] = t31;
  } else {
    t31 = $[71];
  }
  let t32;
  if ($[72] !== errors.email) {
    t32 = errors.email ? <div className="w-[328px] text-red-500 text-sm ">{errors.email.message}</div> : "";
    $[72] = errors.email;
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  let t33;
  if ($[74] !== t31 || $[75] !== t32) {
    t33 = <div className="space-y-2 flex flex-col">{t27}{t31}{t32}</div>;
    $[74] = t31;
    $[75] = t32;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  let t34;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <div className="text-smokeGrey font-medium text-[14px] md:text-[16px]">Your password</div>;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <LockIconOutline />;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] !== register) {
    t37 = register("password", {
      required: "password is required",
      pattern: {
        value: t36,
        message: "Password must include at least one letter, one number, and one special character, and be at least 6 characters long"
      }
    });
    $[80] = register;
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  const t38 = isPasswordVisible ? "text" : "password";
  let t39;
  if ($[82] !== onChangeHandler || $[83] !== signup.password || $[84] !== t37 || $[85] !== t38) {
    t39 = <input {...t37} name="password" type={t38} value={signup.password} onChange={onChangeHandler} placeholder="Enter your password" className="w-full border-none py-1 outline-none" />;
    $[82] = onChangeHandler;
    $[83] = signup.password;
    $[84] = t37;
    $[85] = t38;
    $[86] = t39;
  } else {
    t39 = $[86];
  }
  let t40;
  if ($[87] !== isPasswordVisible) {
    t40 = isPasswordVisible ? <Image src="/Images/view.svg" height={24} width={24} alt="" /> : <Image src="/Images/Hide.svg" height={24} width={24} alt="" />;
    $[87] = isPasswordVisible;
    $[88] = t40;
  } else {
    t40 = $[88];
  }
  let t41;
  if ($[89] !== t40 || $[90] !== togglePasswordVisibility) {
    t41 = <div onClick={togglePasswordVisibility} className="cursor-pointer">{t40}</div>;
    $[89] = t40;
    $[90] = togglePasswordVisibility;
    $[91] = t41;
  } else {
    t41 = $[91];
  }
  let t42;
  if ($[92] !== t39 || $[93] !== t41) {
    t42 = <div className="flex items-center border border-borderLightGrey rounded-lg p-2 gap-2">{t35}{t39}{t41}</div>;
    $[92] = t39;
    $[93] = t41;
    $[94] = t42;
  } else {
    t42 = $[94];
  }
  let t43;
  if ($[95] !== errors.password) {
    t43 = errors.password ? <div className="  text-red-500 text-sm ">{errors.password.message}</div> : "";
    $[95] = errors.password;
    $[96] = t43;
  } else {
    t43 = $[96];
  }
  let t44;
  if ($[97] !== t42 || $[98] !== t43) {
    t44 = <div className="space-y-2 flex flex-col">{t34}{t42}{t43}</div>;
    $[97] = t42;
    $[98] = t43;
    $[99] = t44;
  } else {
    t44 = $[99];
  }
  let t45;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <div className="text-smokeGrey font-medium text-[14px] md:text-[16px]">Repeat password</div>;
    $[100] = t45;
  } else {
    t45 = $[100];
  }
  let t46;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <LockIconOutline />;
    $[101] = t46;
  } else {
    t46 = $[101];
  }
  let t47;
  if ($[102] !== signup.password) {
    t47 = value_0 => value_0 === signup?.password || "password do not match with confirm password";
    $[102] = signup.password;
    $[103] = t47;
  } else {
    t47 = $[103];
  }
  let t48;
  if ($[104] !== register || $[105] !== t47) {
    t48 = register("confirmPassword", {
      required: "confirm password is required",
      validate: t47
    });
    $[104] = register;
    $[105] = t47;
    $[106] = t48;
  } else {
    t48 = $[106];
  }
  let t49;
  if ($[107] !== onChangeHandler || $[108] !== signup.confirmPassword || $[109] !== t48) {
    t49 = <input {...t48} name="confirmPassword" value={signup.confirmPassword} onChange={onChangeHandler} type="password" placeholder="Enter your password" className="w-full border-none py-1 outline-none" />;
    $[107] = onChangeHandler;
    $[108] = signup.confirmPassword;
    $[109] = t48;
    $[110] = t49;
  } else {
    t49 = $[110];
  }
  let t50;
  if ($[111] !== isPasswordVisible) {
    t50 = isPasswordVisible ? <Image src="/Images/view.svg" height={24} width={24} alt="" /> : <Image src="/Images/Hide.svg" height={24} width={24} alt="" />;
    $[111] = isPasswordVisible;
    $[112] = t50;
  } else {
    t50 = $[112];
  }
  let t51;
  if ($[113] !== t50 || $[114] !== togglePasswordVisibility) {
    t51 = <div onClick={togglePasswordVisibility} className="cursor-pointer">{t50}</div>;
    $[113] = t50;
    $[114] = togglePasswordVisibility;
    $[115] = t51;
  } else {
    t51 = $[115];
  }
  let t52;
  if ($[116] !== t49 || $[117] !== t51) {
    t52 = <div className="flex items-center border border-borderLightGrey rounded-lg p-2 gap-2">{t46}{t49}{t51}</div>;
    $[116] = t49;
    $[117] = t51;
    $[118] = t52;
  } else {
    t52 = $[118];
  }
  let t53;
  if ($[119] !== errors.confirmPassword) {
    t53 = errors.confirmPassword ? <div className=" text-red-500 text-sm ">{errors.confirmPassword.message}</div> : "";
    $[119] = errors.confirmPassword;
    $[120] = t53;
  } else {
    t53 = $[120];
  }
  let t54;
  if ($[121] !== t52 || $[122] !== t53) {
    t54 = <div className="space-y-2 flex flex-col">{t45}{t52}{t53}</div>;
    $[121] = t52;
    $[122] = t53;
    $[123] = t54;
  } else {
    t54 = $[123];
  }
  const t55 = isSubmitting ? "Submitting" : "Create account";
  let t56;
  if ($[124] !== t55) {
    t56 = <div className="w-full pt-3"><button className="w-full rounded-lg py-2.5 text-[14px] md:text-[16px] font-medium text-white bg-[#354EF0]">{t55}</button></div>;
    $[124] = t55;
    $[125] = t56;
  } else {
    t56 = $[125];
  }
  let t57;
  if ($[126] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <div className="text-[12px] font-medium text-chocolateGrey flex justify-center pt-2 gap-1">Already have an account?{" "}<Link href="/login" className="text-[12px] font-medium cursor-pointer text-primary-primaryBlue">Log In</Link></div>;
    $[126] = t57;
  } else {
    t57 = $[126];
  }
  let t58;
  if ($[127] !== t13 || $[128] !== t14 || $[129] !== t20 || $[130] !== t26 || $[131] !== t33 || $[132] !== t44 || $[133] !== t54 || $[134] !== t56) {
    t58 = <><div className="reps-herosection-bg mt-5 pt-[110px]"><div className="px-4 lg:px-20 py-10 flex flex-col lg:flex-row justify-center items-center gap-10 w-full">{t12}<form onSubmit={t13} className="lg:w-[45%] w-full bg-white space-y-5 mt-5 lg:mt-0 rounded-lg shadow-lg p-5 sm:p-7">{t14}{t20}{t26}{t33}{t44}{t54}{t56}{t57}</form></div></div></>;
    $[127] = t13;
    $[128] = t14;
    $[129] = t20;
    $[130] = t26;
    $[131] = t33;
    $[132] = t44;
    $[133] = t54;
    $[134] = t56;
    $[135] = t58;
  } else {
    t58 = $[135];
  }
  return t58;
};
export default RepsHerosections;
function _temp(state) {
  return state?.userData?.userData?.user;
}
function _temp2(state_0) {
  return state_0?.token?.token;
}